import React from 'react';
import { BellIcon, UserCircleIcon } from '@heroicons/react/outline';

const Header = () => {
    const adminUser = JSON.parse(localStorage.getItem('adminUser') || '{}');

    return (
        <header className="bg-white shadow-sm border-b border-gray-200">
            <div className="px-6 py-4 flex justify-between items-center">
                <div>
                    <h2 className="text-xl font-semibold text-[#063b56]">Dashboard</h2>
                    <p className="text-sm text-gray-500">Welcome back, {adminUser.first_name || 'Admin'}</p>
                </div>

                <div className="flex items-center space-x-4">
                    <button className="p-2 text-gray-400 hover:text-[#ff9f2f] transition-colors">
                        <BellIcon className="h-6 w-6" />
                    </button>
                    <div className="flex items-center space-x-2 bg-gray-50 px-3 py-2 rounded-lg border border-gray-200">
                        <UserCircleIcon className="h-8 w-8 text-[#063b56]" />
                        <span className="text-sm text-gray-700 font-medium">{adminUser.email}</span>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;